import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { DataNotFoundAlert } from 'components/DataNotFoundAlert';
import { ErrorAlert } from 'components/ErrorAlert';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { useUserContext } from 'contexts/UserContext';
import { ManageSmartAssistantPage } from 'pages/ManageSmartAssistant/ManageSmartAssistantPage';
import { useParams } from 'react-router-dom';
import { SmartAssistantService } from 'services/smart-assistant-service';
import { SMART_ASSISTANT_QUERY_KEY } from 'shared/constants/query-keys';

export function ManageSmartAssistantPageWrapper() {
  const [user] = useUserContext();
  const { smartAssistantId } = useParams();

  const smartAssistantQuery = useQuery({
    queryKey: [SMART_ASSISTANT_QUERY_KEY, { smartAssistantId }],
    queryFn: () => {
      if (smartAssistantId) return SmartAssistantService.getSmartAssistantById(smartAssistantId);
    },
    enabled: !!smartAssistantId
  });

  if (!smartAssistantId) {
    return <ErrorAlert />;
  }

  if (smartAssistantQuery.isLoading) {
    return <FullScreenLoader />;
  }

  if (smartAssistantQuery.isError || !smartAssistantQuery.data) {
    return <ErrorAlert />;
  }

  const smartAssistant = smartAssistantQuery.data;

  if (smartAssistant.creator !== user._id) {
    return <DataNotFoundAlert w="100%" h="100%" />;
  }

  return <ManageSmartAssistantPage smartAssistant={smartAssistant} avatarUrl={smartAssistant.avatarUrl} />;
}
